import S3Utils     from '../../packages/s3-utils';
import Aws         from '../../services/aws';
import DashStreams from '../../services/dash-streams';

/**
 * @param {string}  originalUrl             - s3 url to raw video
 * @param {object}  [options]
 * @param {boolean} [options.fallback=true] - fallback to raw video if creating
 *                                            the dash stream fails
 * @returns {object} vjsSrc
 * @returns {string} vjsSrc.src
 * @returns {string} vjsSrc.type
 */
export async function getVideoJsSource(originalUrl, options) {

    // Normalize the options
    options = Object.assign({}, options);
    if (options.fallback !== false) {
        options.fallback = true;
    }

    async function getOriginalSource(s3Bucket, s3Key) {

        // Just sign the original url
        const signedUrl = (
            await Aws.getPresignedUrl(
                null,
                s3Bucket,
                s3Key,
                'getObject',
            )
        ).data;
        return {
            src: signedUrl,
            type: 'video/mp4',
        };
    }

    async function getStreamSource(s3Bucket, s3Key) {

        // Convert the input bucket to a stream bucket
        const rawToStreamBucket = {
            'ttto-course-videos-raw': 'ttto-course-videos-streams',
            'ttto-feedback':          'ttto-feedback-videos-streams',
            'ttto-intro-videos':      'ttto-intro-videos-streams',
            'ttto-kb-videos-full':    'ttto-kb-videos-streams',
        };
        s3Bucket = rawToStreamBucket[s3Bucket];
        if (!s3Bucket) {
            throw new Error('unsupported bucket');
        }

        // Convert the input key to a stream key (currently only required to
        // remove file extensions from raw course videos)
        s3Key = s3Key.split('.')[0];

        // Create the stream
        const s3PlaylistUrl = ''.concat(
            'https://s3-us-west-2.amazonaws.com',
            `/${s3Bucket}`,
            `/${s3Key}`,
            '/playlist.mpd',
        );
        const stream = await DashStreams.createStream({
            url: s3PlaylistUrl
        });

        // Build the source object
        const playlistUrl = DashStreams.getStreamPlaylistUrl(
            stream.longId
        );
        return {
            src: playlistUrl,
            type: 'application/dash+xml',
        };
    }

    // Parse the source URL
    const s3Obj = S3Utils.parseS3Url(originalUrl);

    // Try the stream version before falling back to the original
    try {
        return await getStreamSource(s3Obj.bucket, s3Obj.key);
    } catch (err) {
        if (options.fallback) {
            return await getOriginalSource(s3Obj.bucket, s3Obj.key);
        }
        throw err;
    }
}

/**
 * @param {object} vjsSrc
 * @param {string} vjsSrc.src
 * @param {string} vjsSrc.type
 * @returns {boolean}
 */
export function isVideoJsSourceDash(vjsSrc) {
    return vjsSrc.type === 'application/dash+xml';
}

export default {
    getVideoJsSource,
    isVideoJsSourceDash,
};



// WEBPACK FOOTER //
// ./src/packages/mpeg-dash-utils/index.js